import { splitWord, validDateField, validStringField } from "../../helpers/HelperFunctions";
import { Fragment, useCallback, useState } from "react";
import { IReport } from "../../helpers/Interfaces";
import ArrowRightIcon from "../../assets/images/ArrowRight.svg";
import ShareIcon from "../../assets/images/Share.svg";
import SearchIcon from "../../assets/images/Search.svg";
import DropdownIcon from "../../assets/images/Dropdown.svg";
import { ReportFilterTypes } from "../../helpers/Types";
import RemoveFilter from "../../assets/images/RemoveFilter.svg";
import SearchableDown from "../../components/SearchableDown/SearchableDown";

export default function CompletedReportsUI(props: {
    reports: IReport[], setSelectedReport: CallableFunction;
    openView: CallableFunction; filter: (filterBy: ReportFilterTypes, query: string) => void;
    cancelFilter: boolean; resetDefault: CallableFunction
}) {

    const [anchorSearcherEl, setAnchorSearcherEl] = useState<HTMLImageElement>(null as any);
    const [selectedFilter, setSelectedFilter] = useState<ReportFilterTypes>("patientName");
    const [showSearch, setShowSearch] = useState(true);
    const [isAscending, setIsAscending] = useState(true);

    const openSearch = Boolean(anchorSearcherEl);

    const handleClick = useCallback((selectedReport: IReport, open: "view" | "generateLink") => {
        props.setSelectedReport(selectedReport);
        props.openView(open);
    }, []);

    const handleSearchOpen = (event: React.MouseEvent<HTMLImageElement>, filterBy: ReportFilterTypes) => {
        setAnchorSearcherEl(event.currentTarget);
        setSelectedFilter(filterBy);
    };

    const handleSearchClose = () => {
        setAnchorSearcherEl(null as any);
        setShowSearch(true);
    };

    const handleSelectedItem = (selectedValue: string) => {
        props.filter(selectedFilter, selectedValue);
        setAnchorSearcherEl(null as any);
        setShowSearch(true);
    };

    const handleClearFilter = () => {
        props.resetDefault()
    };

    function getInitialValues() {

        let valueArr = [] as any[];

        props.reports.forEach(report => {
            valueArr.push(report[selectedFilter])
        });

        let distinctValues = valueArr.filter((value, index, array) => array.indexOf(value) === index);

        return distinctValues;
    }

    function getSortedReports() {
        const allReports = [...props.reports];

        return allReports.sort((a, b) => {
            const timeA = a.completedDate ? new Date(a.completedDate).getTime() : Infinity;
            const timeB = b.completedDate ? new Date(b.completedDate).getTime() : Infinity;

            return isAscending ? timeA - timeB : timeB - timeA;
        });
    }

    return (<div className="table animated animatedFadeInUp fadeInUp">
        <div className="header">
            <div className="header-row large">
                <span className="large-text">Patient Name</span>
                <img onClick={(value) => handleSearchOpen(value, "patientName")} className="icon" src={SearchIcon} alt={"Search"} />
            </div>
            <div className="header-row small">
                <span className="large-text">Report Type</span>
                <img onClick={(value) => handleSearchOpen(value, "reportType")} className="icon" src={SearchIcon} alt={"Search"} />
            </div>
            <div className="header-row small">
                <span className="large-text">Referrer</span>
                <img onClick={(value) => handleSearchOpen(value, "referrer")} className="icon" src={SearchIcon} alt={"Search"} />
            </div>
            <div className="header-row small">
                <span className="large-text">Clinic</span>
                <img onClick={(value) => handleSearchOpen(value, "clinic")} className="icon" src={SearchIcon} alt={"Search"} />
            </div>
            <div className="header-row small">
                <span className="large-text">Completed Date</span>
                <img onClick={() => setIsAscending(!isAscending)} src={DropdownIcon} alt="SortArrow" className={isAscending ? "img" : "invert-img"} />
            </div>
            <div className="header-row small">
                <span className="large-text">Invoice</span>
            </div>
            <div className="header-row small">
                <div className="filter-content">
                    {props.cancelFilter
                        ? <img className="filter-icon" src={RemoveFilter} alt={"RemoveFilter"} onClick={handleClearFilter} />
                        : <div className="filter-icon" />
                    }
                </div>
            </div>
        </div>
        <div className="data animated animatedFadeInUp fadeInUp">
            {getSortedReports().map((report) => {
                return (<div key={report.id} className="data-row" onClick={() => { handleClick(report, "view"); }}>
                    <span className="cell large-text large">
                        {validStringField(report.patientName)}
                    </span>
                    <div className="cell large-text small">{validStringField(report.reportType)}</div>
                    <div className="cell large-text small">{validStringField(report.referrer)}</div>
                    <span className="cell large-text small">
                        {validStringField(report.clinic)}
                    </span>
                    <span className="cell large-text small">{validDateField(report.completedDate)}</span>
                    <span className="cell large-text small">{splitWord(report.invoiceStatus)}</span>
                    <span className="cell large-text small flex-end">
                        <div>
                            <img className="action" src={ShareIcon} alt={"Share"} onClick={(e) => { e.stopPropagation(); handleClick(report, "generateLink"); }} />
                            <img className="action" src={ArrowRightIcon} alt={"Arrow"} />
                        </div>
                    </span>
                </div>);
            })}
        </div>
        {openSearch
            ? (<SearchableDown open={openSearch} anchorEl={anchorSearcherEl} onClose={handleSearchClose}
                initialDetails={getInitialValues()} onClick={(selectedValue: string) => { handleSelectedItem(selectedValue); }}
                searchable={showSearch} />)
            : (<Fragment />)
        }
    </div>)
}